/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ActionButton, colors, mixins } from '@blend/consumer-components';
import { useDispatch } from 'react-redux';

import { AxiosError } from 'axios';
import { NavigationSidebar } from '../../../components/common/NavigationSidebar/NavigationSidebar';
import { notaryAPI } from '../../../api/notary';
import { addNotifications } from '../../../actions/pageActions';
import { NotificationItem } from '../../../components/common/Notifications/NotificationItem';
import { titleCase } from '@utils/formatting';
import { diagnostics } from '@utils/diagnostics';

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  inviteWrapper: {
    width: '20%',
    height: '100%',
    ...mixins.margin(20),
  },
  emailInput: {
    width: '100%',
    height: '100%',
  },
});

export namespace InvitePage {
  export interface Props {}
}

export const InvitePage: React.FC<InvitePage.Props> = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState<string>('');
  return (
    <div className={css(styles.wrapper)} data-it="InvitePage">
      <NavigationSidebar />
      <div className={css(styles.inviteWrapper)}>
        <form>
          <input
            className={css(styles.emailInput)}
            type="text"
            name="email"
            placeholder="Email"
            value={email}
            onChange={e => {
              setEmail(e.target.value);
            }}
          />
          <ActionButton
            data-dd-privacy="allow"
            onClick={async () => {
              try {
                await notaryAPI.accounts.inviteNotary(email);
              } catch (err) {
                const notifications: NotificationItem.PropsWithoutId[] = [
                  {
                    type: 'error',
                    iconType: 'error',
                    content:
                      titleCase((err as AxiosError<{ message?: string }>).response?.data?.message) ||
                      'That action could not be completed. Try again.',
                    shouldAutoRemove: false,
                  },
                ];
                addNotifications(notifications)(dispatch);
              }
            }}
            option={'secondary'}
            data-it="ActionButton-Save"
            color={colors.black}
          >
            Invite
          </ActionButton>
          <ActionButton
            data-dd-privacy="allow"
            onClick={() => {
              diagnostics.error(new Error(`Sent test Sentry message ${Math.random()}`));
            }}
            option={'secondary'}
            color={colors.black}
          >
            Send Test Sentry Message
          </ActionButton>
        </form>
      </div>
    </div>
  );
};
